import React from 'react';
import NavigationGrid from '../components/NavigationGrid';
import dashboardsConfig from '../config/dashboards.json';

const Home = () => {
  return (
    <NavigationGrid 
      dashboards={dashboardsConfig.dashboards} 
      categories={dashboardsConfig.categories}
    />
  );
};

export default Home; 